import React from "react";
import { Box, Link } from "@material-ui/core";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const StyledLink = styled(Link)`
  border: 1px solid #bdbdbd;
  border-radius: 8px;
  padding: 20px;
  margin: 10px 50px;
  width: 300px;
  text-decoration: none;
  &:hover {
    background-color: #eee;
    text-decoration: none;
  }
`;

const Analytics: React.FC = () => {
  const { t } = useTranslation("analytics");
  const list = [
    { href: "/accounting", label: t("accounting") },
    { href: "/callHistory", label: t("callHistory") },
    { href: "/callHistory/graph", label: t("callHistoryGraph") },
    { href: "/castAnalyticsRanking", label: t("castAnalytics") },
    { href: "/guestAnalytics/detail", label: t("guestAnalytics") },
    { href: "/guestAnalytics", label: t("cpmGuestList") },
    { href: "/guestAnalytics/summarySales", label: t("salesSummary") },
    { href: "/guestAnalytics/profileSales", label: t("salesByProfile") },
    { href: "/guestAnalytics/areaSales", label: t("salesByArea") },
    { href: "/guestAnalytics/salesVolume", label: t("salesYoYComparison") },
    { href: "/guestAnalytics/cpmAnalytics", label: t("cpmAnalytics") },
    { href: "/guestAnalytics/mediaLtv", label: t("ltvByMedia") },
    { href: "/guestAnalytics/guestGroupLtv", label: t("ltvByRank") },
    { href: "/guestAnalytics/recruitingMediaLtv", label: t("ltvByRecruitingMedia") },
  ];

  return (
    <>
      <Box display="flex" flexWrap="wrap" style={{ margin: "20px" }}>
        {list.map((item) => (
          <StyledLink href={item.href} key={item.href}>
            {item.label}
          </StyledLink>
        ))}
      </Box>
    </>
  );
};
export default Analytics;
